define('shared/page/env',['$', 'shared/lib/RSVP'], function ($, RSVP) {
    'use strict';

    var $html = $('html');

    return function(){
        var result = 'uat';
        if ($html.hasClass('runmode-live')) {
          result = 'live';
        } else if ($html.hasClass('runmode-qa')) {
          result = 'qa';
        } else if ($html.hasClass('runmode-stg')) {
          result = 'stg';
        }

        return RSVP.resolve(result);
    };
});
